import { Card, Col, Row, Typography } from 'antd';
import { FileProtectOutlined, InfoCircleOutlined, LinkOutlined, CopyrightOutlined } from '@ant-design/icons';
import SEO from '../components/SEO/SEO';

const { Title, Paragraph } = Typography;

const iconCircleStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  borderRadius: '50%',
  background: 'linear-gradient(135deg, rgba(145, 149, 252, 0.15), rgba(191, 193, 255, 0.15))',
  marginBottom: 16
};

const sections = [
  {
    icon: <InfoCircleOutlined className="text-primary" style={{ fontSize: 26 }} />,
    title: 'Disclaimer of Warranties',
    content: 'This website is provided as-is, without any warranty of any kind, express or implied, including but not limited to the warranties of merchantability, fitness for a particular purpose, and non-infringement. In no event shall the authors, contributors, or owners of this website be liable for any claim, damages or other liability, whether in an action of contract, tort or otherwise, arising from, out of, or in connection with the website or the use or other dealings in the website.'
  },
  {
    icon: <FileProtectOutlined className="text-primary" style={{ fontSize: 26 }} />,
    title: 'Informational Purposes Only',
    content: 'The content on this website is provided for informational purposes only and does not constitute professional advice or recommendations of any kind. No representation or warranty, express or implied, is made regarding the accuracy, completeness, or reliability of the information contained herein. Any reliance on such information is at your own risk.'
  },
  {
    icon: <LinkOutlined className="text-primary" style={{ fontSize: 26 }} />,
    title: 'External Links',
    content: 'This website may contain links to other websites that are not under the control of NDE Archive. There is no responsibility for the content of these linked websites, nor is there any endorsement or approval of any products or services mentioned on these sites. Use these links at your own risk.'
  },
  {
    icon: <CopyrightOutlined className="text-primary" style={{ fontSize: 26 }} />,
    title: 'Copyright and Intellectual Property',
    content: [
      'The content on this website is protected by copyright and other laws. You may not modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell any information, software, products or services obtained from this website without the prior written consent of the authors or owners.',
      'We do not display the full text of near-death experience accounts due to copyright restrictions held by the original sources. For the complete account and all details, please always refer to the original source linked on each experience\'s page.'
    ]
  }
];

const LegalNoticeScreen = () => {
  return (
    <>
      <SEO
        title="Legal Notice"
        description="Legal notice and disclaimer for NDE Archive. Information about warranties, intellectual property, and external links."
        path="/legal-notice"
      />
      <Row justify="center">
        <Col xs={24} md={20} lg={16} className="mb-64">
          <div className="text-center mb-42" style={{ marginTop: 16 }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(145, 149, 252, 0.15), rgba(191, 193, 255, 0.15))',
              marginBottom: 20
            }}>
              <FileProtectOutlined className="text-primary" style={{ fontSize: 36 }} />
            </div>
            <Title level={1} style={{ color: '#1a1a2e', fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 8 }}>Legal Notice</Title>
            <Paragraph style={{ color: '#555', fontSize: 16, maxWidth: 560, margin: '0 auto' }}>
            Please read the following legal information carefully before using this website.
            </Paragraph>
          </div>

          <Row gutter={[24, 24]}>
            {sections.map((section, index) => (
              <Col xs={24} key={index}>
                <Card
                  className="h-100 elevation hover-elevation-2"
                  bordered={false}
                  style={{ borderRadius: 16, overflow: 'hidden' }}
                >
                  <div style={iconCircleStyle}>{section.icon}</div>
                  <Title level={4} style={{ marginBottom: 12 }}>{section.title}</Title>
                  {Array.isArray(section.content)
                    ? section.content.map((para, i) => (
                      <Paragraph key={i} style={{ color: '#555', fontSize: 15, lineHeight: '24px', marginBottom: i < section.content.length - 1 ? 12 : 0 }}>
                        {para}
                      </Paragraph>
                    ))
                    : <Paragraph style={{ color: '#555', fontSize: 15, lineHeight: '24px', marginBottom: 0 }}>{section.content}</Paragraph>
                  }
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default LegalNoticeScreen;
